<template>
  <span :class="`traveler-label`">
    <traveler-icon
      v-if="with_icon"
      :traveler="traveler_info"
      :color="sass('primary')"
    />
    <span v-if="use_name">
      {{ traveler_name }}
    </span>
    <span v-else>
      Passeggero <span v-if="index >= 0">{{ index + 1 }} </span>
      <span v-else>{{ traveler_info.id }}</span>
    </span>
    <span>({{ traveler_type }})</span>
    <slot></slot>
  </span>
</template>

<script>
  import { mapState } from 'vuex';

  import TravelerIcon from './traveler-icon.vue';
  import {
    traveler_name,
    transcode_traveler_type,
  } from '@liveflight/utilities';
  import { committed_age, enforced_age } from '@liveflight/utilities/travelers';
  import { declared_age_label } from '@/utilities/birthdate';

  export default {
    name: 'traveler-label',
    components: {
      'traveler-icon': TravelerIcon,
    },
    props: {
      traveler_info: {
        type: Object,
        default: () => ({}),
      },
      index: {
        type: Number,
        default: () => -1,
      },
      use_name: {
        type: Boolean,
        default: false,
      },
      with_icon: {
        type: Boolean,
        default: false,
      },
      // Aggiunge l'età dichiarata in ricerca accanto al tipo, come nel form
      // passeggeri alpitour: "Passeggero 4 (bambino 11 anni)".
      show_age: {
        type: Boolean,
        default: false,
      },
    },
    computed: {
      ...mapState('liveflight', ['committed_traveler_ages']),
      // Solo l'età che i bound applicano davvero: adulti e neonati restano
      // senza, per i neonati Kyte ri-sequenzia gli id e l'età non è affidabile.
      declared_age() {
        return enforced_age(
          this.traveler_info,
          committed_age(this.committed_traveler_ages, this.traveler_info.id)
        );
      },
      traveler_type() {
        const type = transcode_traveler_type(this.traveler_info, 1);
        if (!this.show_age || this.declared_age === null) {
          return type;
        }
        return `${type} ${declared_age_label(this.declared_age)}`;
      },
      traveler_name() {
        return traveler_name(this.traveler_info);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .traveler-label {
    margin: 0;
    flex-grow: 1;
    text-align: left;

    display: flex;
    align-items: center;
    gap: 5px;

    font-size: 16px;
    font-weight: $vb-font-weight-semibold;
  }
</style>
